import { AuthorizationResourcesAndSubjects } from '@/types/authorization'
import { defineStore } from 'pinia'

export enum EModals {
  UPDATE_BULK_STATION = 'UPDATE_BULK_STATION',
  REMOVE_BULK_STATION = 'REMOVE_BULK_STATION',
  FILTER_STATION = 'FILTER_STATION',
  FILTER_DASHBOARD = 'FILTER_DASHBOARD',
  UPDATE_SCHEDULE = 'UPDATE_SCHEDULE',
  EDIT_SCHEDULE = 'EDIT_SCHEDULE',
  UPDATE_POSITION = 'UPDATE_POSITION',
  REMOVE_SCHEDULE = 'REMOVE_SCHEDULE',
  REMOVE_POSITION = 'REMOVE_POSITION',
  EXPORT_DASHBOARD_EXCEL = 'EXPORT_DASHBOARD_EXCEL',
  EXPORT_STATIONS_EXCEL = 'EXPORT_STATIONS_EXCEL',
  EXPORT_DASHBOARD_STATIONS = 'EXPORT_DASHBOARD_STATIONS',
  DOCTOR_SIGNUP = 'DOCTOR_SIGNUP',
  LEGENDS = 'LEGENDS',
  SHARE = 'SHARE',
  SHARE_POLICY = 'SHARE_POLICY',
  CREATE_SHEDULE = 'CREATE_SHEDULE',
  CREATE_GROUP_MODAL = 'CREATE_GROUP_MODAL',
  UPDATE_GROUP_MODAL = 'UPDATE_GROUP_MODAL',
  CREATE_USER_MODAL = 'CREATE_USER_MODAL',
  POSITIONS_MODAL = 'POSITIONS_MODAL',
  POLICIES_MODAL = 'POLICIES_MODAL',
  RESOURCE_POLICIES_MODAL = 'RESOURCE_POLICIES_MODAL',
  FILTER_SOLICITATIONS = 'FILTER_SOLICITATIONS',
  SCHEDULE_VISIBILITY_MODAL = 'SCHEDULE_VISIBILITY_MODAL',
  NOTIFICATION_DETAIL = 'NOTIFICATION_DETAIL',
  CHECK_ATTEMPTS = 'CHECK_ATTEMPTS',
  PERMISSIONS_TREE = 'PERMISSIONS_TREE'
}

export type shareModalDataType = {
  resourceName: string
  resourceType: AuthorizationResourcesAndSubjects
  resourceId: number
  timezone?: string
  breadcrumb?: string[]
  companyId?: number
}

export type checkAttemptsModalDataType = {
  stationId: number
  doctorName: string
  date: string
  hours: string
  schedule: string
  [key: string]: unknown
}

export type permissionsTreeModalDataType = {
  subjectId: number
  subjectType: AuthorizationResourcesAndSubjects
  subjectName?: string
}

export type ModalMetadata =
  | shareModalDataType
  | checkAttemptsModalDataType
  | permissionsTreeModalDataType
  | Record<string, unknown>

export type ModalState = {
  modals: Record<EModals, boolean>
  metadata: ModalMetadata | undefined
  showAlert: boolean
  alertDescription: string
  alertMaxWidth: string | undefined
}

export const useModalStore = defineStore('modal', {
  state: (): ModalState => ({
    modals: {
      [EModals.REMOVE_SCHEDULE]: false,
      [EModals.REMOVE_POSITION]: false,
      [EModals.UPDATE_SCHEDULE]: false,
      [EModals.EDIT_SCHEDULE]: false,
      [EModals.UPDATE_POSITION]: false,
      [EModals.FILTER_STATION]: false,
      [EModals.UPDATE_BULK_STATION]: false,
      [EModals.REMOVE_BULK_STATION]: false,
      [EModals.EXPORT_DASHBOARD_EXCEL]: false,
      [EModals.EXPORT_STATIONS_EXCEL]: false,
      [EModals.EXPORT_DASHBOARD_STATIONS]: false,
      [EModals.DOCTOR_SIGNUP]: false,
      [EModals.FILTER_DASHBOARD]: false,
      [EModals.SHARE]: false,
      [EModals.SHARE_POLICY]: false,
      [EModals.LEGENDS]: false,
      [EModals.CREATE_GROUP_MODAL]: false,
      [EModals.CREATE_USER_MODAL]: false,
      [EModals.UPDATE_GROUP_MODAL]: false,
      [EModals.POSITIONS_MODAL]: false,
      [EModals.POLICIES_MODAL]: false,
      [EModals.RESOURCE_POLICIES_MODAL]: false,
      [EModals.CREATE_SHEDULE]: false,
      [EModals.FILTER_SOLICITATIONS]: false,
      [EModals.SCHEDULE_VISIBILITY_MODAL]: false,
      [EModals.NOTIFICATION_DETAIL]: false,
      [EModals.CHECK_ATTEMPTS]: false,
      [EModals.PERMISSIONS_TREE]: false
    },
    metadata: undefined,
    alertDescription: '',
    showAlert: false,
    alertMaxWidth: undefined
  }),
  actions: {
    toggleModal(modal: EModals, metadata?: ModalMetadata) {
      const isOpenModal = !this.modals[modal]

      if (metadata && isOpenModal) {
        this.metadata = metadata
      }

      this.modals = { ...this.modals, [modal]: isOpenModal }

      if (!isOpenModal) {
        this.metadata = undefined
      }
    },
    toggleShowAlert() {
      this.showAlert = !this.showAlert
      if (!this.showAlert) {
        this.alertMaxWidth = undefined
      }
    }
  }
})
